import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'
import NameCircle from 'components/UI/NameCircle'
import __R, {userCan} from 'containers/__R';

class TeacherListTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    lessonInfo: PropTypes.object.isRequired
  }

  render(){
    let {lessonInfo, classDetail} = this.props;
    let {cType} = classDetail.detail;
    let {teacher_list} = lessonInfo;
    const maxZIndex = teacher_list.length;

    if(userCan(cType == 0 ? 'read_class_teacher' : 'read_private_class_teacher')){
      return(
        <div className='lesson-teacher-list'>
          {teacher_list.map((teacher, index) => {
            return(
              <NameCircle
                key={index}
                firstName={teacher.stName}
                showFullName={false}
                style={{zIndex: maxZIndex - index}}
              />
            )
          })}
        </div>
      )
    } else{
      return (
        <div />
      )
    }
  }
}

export default (TeacherListTd)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/LessonTable/TeacherListTd.js